import { useState } from "react";
import { Edit3, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { createCompany, updateCompany } from "@/lib/api";

const blankCompany = { name: "", city: "", tutor_name: "", tutor_email: "", sector: "", adresse_complete: "", siret: "", effectif: "", tuteur_fonction: "", tuteur_telephone: "" };
const optionalText = ["adresse_complete", "siret", "tuteur_fonction", "tuteur_telephone"];

const buildForm = (company) => ({ ...blankCompany, ...(company || {}), effectif: company?.effectif ?? "" });
const cleanPayload = (form) => ({
  ...Object.fromEntries(Object.entries(form).map(([key, value]) => [key, optionalText.includes(key) && value === "" ? null : value])),
  effectif: form.effectif === "" || form.effectif === null ? null : Number(form.effectif),
});

export default function CompanyDialog({ onSaved, company = null, testIdPrefix = "company-create" }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(buildForm(company));
  const isEdit = Boolean(company);
  const update = (key, value) => setForm((current) => ({ ...current, [key]: value }));
  const fields = [
    ["name", "Entreprise", "text", true], ["city", "Ville", "text", true], ["sector", "Secteur", "text", true],
    ["adresse_complete", "Adresse complète", "text", false], ["siret", "SIRET", "text", false], ["effectif", "Effectif", "number", false],
    ["tutor_name", "Nom du tuteur", "text", true], ["tuteur_fonction", "Fonction du tuteur", "text", false], ["tutor_email", "Email tuteur", "email", true], ["tuteur_telephone", "Téléphone tuteur", "text", false],
  ];
  const submit = async (event) => {
    event.preventDefault();
    const saved = isEdit ? await updateCompany(company.id, cleanPayload(form)) : await createCompany(cleanPayload(form));
    onSaved(saved);
    setOpen(false);
    if (!isEdit) setForm(blankCompany);
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button variant="outline" className="rounded-none" data-testid={`${testIdPrefix}-open-button`}>{isEdit ? <Edit3 className="h-4 w-4" /> : <Plus className="h-4 w-4" />}{isEdit ? "Modifier" : "Ajouter entreprise"}</Button></DialogTrigger>
      <DialogContent className="max-h-[88vh] overflow-y-auto rounded-none sm:max-w-2xl" data-testid={`${testIdPrefix}-dialog`}>
        <DialogHeader><DialogTitle className="font-display text-2xl" data-testid={`${testIdPrefix}-dialog-title`}>{isEdit ? "Modifier l’entreprise" : "Nouvelle entreprise"}</DialogTitle><DialogDescription data-testid={`${testIdPrefix}-dialog-description`}>Entreprise d’accueil, capacité et coordonnées du tuteur.</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid={`${testIdPrefix}-form`}>
          {fields.map(([key, label, type, required]) => <div className="space-y-2" key={key}><Label htmlFor={`${testIdPrefix}-${key}`} data-testid={`${testIdPrefix}-${key}-label`}>{label}</Label><Input id={`${testIdPrefix}-${key}`} required={required} type={type} value={form[key] ?? ""} onChange={(event) => update(key, event.target.value)} className="rounded-none" data-testid={`${testIdPrefix}-${key}-input`} /></div>)}
          <Button type="submit" className="rounded-none bg-[#002FA7] sm:col-span-2" data-testid={`${testIdPrefix}-submit-button`}>{isEdit ? "Enregistrer" : "Ajouter"}</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}